import { getStatusText, getBackColor, getForeColor } from "../../common/utils";
import { BackForeColor } from "./BackForeColor";

export default function RequestStatus({ status }) {
  
  return (
    <BackForeColor
      backColor={getBackColor(status)}
      foreColor={getForeColor(status)}
      text={getStatusText(status)}
    />
  );
}
